export default "__VITE_ASSET__B3zFWSqj__"